// TODO: convert this to modules so we don't import modules in components
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { useTranslate } from 'lib/tolgee'
import { TypeFilter } from 'modules/territory'
import { getLanguageVariables } from 'pages/SearchTerritoriesPage/utils/getLanguageVariable'
import { UserStore } from 'stores'
import { TOLGEE_GLOBALS } from 'utils'

import AudienceFilter from './components/AudienceFilter'
import CategoriesFilter from './components/CategoriesFilter'
import DateRangeFilter from './components/DateRangeFilter'
import LanguageFilter from './components/LanguageFilter'
import TopicsFilter from './components/TopicsFilter'
import { FILTER_COMPONENT_OPTIONS } from './consts'
import type { ITerritoryChipsFilter } from './types'
import './index.scss'

export default function TerritoryChipsFilter({ shouldHideTypeFilter }: ITerritoryChipsFilter) {
  const t = useTranslate()

  const location = useLocation()

  const languageOptions = useMemo(() => {
    const userLanguages = UserStore.userLanguageOptions
      .filter(language => !language.disabled)
      .map(language => {
        return {
          value: language.value,
          label: t(TOLGEE_GLOBALS[language.value]),
        }
      })
    const availableLanguages = [...userLanguages]
    return [{ label: t(TOLGEE_GLOBALS.allLanguages), value: null }, ...availableLanguages]
  }, [t])

  const categoriesValue = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)

    const categoriesValue = searchParams.get('categories')

    return categoriesValue
  }, [location.search])

  const languages = useMemo(() => {
    const newSearchParams = new URLSearchParams(location.search)

    const languageValue = newSearchParams.get('languages')
    const selectedLanguage = languageOptions.find(item => item.value === languageValue)

    return languageValue ? selectedLanguage : null
  }, [languageOptions, location.search])

  const territoryTypesValue = useMemo(() => {
    const newSearchParams = new URLSearchParams(location.search)

    const territoryTypesValue = newSearchParams.get('territoryTypes')

    if (!territoryTypesValue) {
      return null
    }

    return territoryTypesValue
  }, [location.search])

  const languageValue = useMemo(() => {
    return getLanguageVariables(languages, territoryTypesValue)
  }, [languages, territoryTypesValue])

  const isTopicTerritory = ['musicTopics', 'musicSubtopics'].includes(String(territoryTypesValue))
  const isBrandCategory = ['brandCategory'].includes(String(territoryTypesValue))

  const isTerritoryTypeSelected = Boolean(territoryTypesValue)

  return (
    <div className="TerritoryChipsFilter-wrapper">
      {!shouldHideTypeFilter && <TypeFilter />}
      {isTerritoryTypeSelected && (
        <div className="aditionalFilters">
          <div className="verticalLine" />
          {FILTER_COMPONENT_OPTIONS[territoryTypesValue]?.includes('categories') && (
            <CategoriesFilter languages={languageValue} />
          )}
          {FILTER_COMPONENT_OPTIONS[territoryTypesValue]?.includes('topics') && (
            <TopicsFilter languages={languageValue} categories={categoriesValue} />
          )}
        </div>
      )}
      <div className="generalFilters">
        <DateRangeFilter />
        <AudienceFilter />
        <LanguageFilter isDisabled={isTopicTerritory || isBrandCategory} />
      </div>
    </div>
  )
}
